// import { useState } from 'react';
// import { Switch, Stack, Text } from '@chakra-ui/react';

// function ToggleSwitch({ isToggled, setIsToggled }) {
//   const handleToggle = () => setIsToggled(!isToggled);

//   return (
//     <Stack direction="row" align="center">
//       <Text>Absolute Score</Text>
//       <Switch isChecked={isToggled} onChange={handleToggle} />
//     </Stack>
//   );
// }

// export default ToggleSwitch;






import { useState, useRef } from "react";
import { Switch, Stack, Text, Button, useToast } from "@chakra-ui/react";
import { AnalyticsDataDownloade } from "utils/activitycontrols/activities";

function ToggleSwitch({ 
  isToggled, 
  setIsToggled, 
  selected, 
  UserRole,           
  creatorOptions,     
  storageCreatorId,   
  pageSize = 100000   
}) {
  const [isDownloading, setIsDownloading] = useState(false);
  const isFetchingRef = useRef(false);
  const toast = useToast();

  const handleToggle = () => setIsToggled(!isToggled);

  // ✅ FIXED: Only fix if value is invalid, otherwise pass through
  const fixProgressValue = (progress) => {
    // If already a valid string with %, return as is
    if (typeof progress === 'string' && progress.includes('%')) {
      return progress;
    }
    
    // If already a valid number (like 100), convert to %
    if (typeof progress === 'number' && !isNaN(progress)) {
      return `${Math.round(progress)}%`;
    }
    
    // If null or undefined
    if (!progress) return "0%";
    
    // If it's an array (like [100])
    if (Array.isArray(progress)) {
      if (progress.length === 0) return "0%";
      const value = progress[0];
      if (typeof value === 'number') {
        return `${Math.round(value)}%`;
      }
      if (typeof value === 'string') {
        return value.includes('%') ? value : `${value}%`;
      }
      return "0%";
    }
    
    // If it's an object with percentage property
    if (typeof progress === 'object' && progress !== null) {
      if (progress.percentage) return progress.percentage;
      if (progress.progress) return fixProgressValue(progress.progress);
      return "0%";
    }
    
    // If it's a plain string without %, add %
    if (typeof progress === 'string') {
      return `${progress}%`;
    }
    
    return "0%";
  };

  // ✅ FIXED: Only fix if value is invalid
  const fixTimeSpent = (timeData) => {
    // If already valid format (MM:SS), return as is
    if (typeof timeData === 'string' && timeData.includes(':') && timeData !== "0:00") {
      return timeData;
    }
    
    if (!timeData) return "0:00";
    
    // If it's a string like "1:27"
    if (typeof timeData === 'string') {
      if (timeData.includes(':')) return timeData;
      // If string is number like "87"
      const num = parseInt(timeData);
      if (!isNaN(num)) {
        const minutes = Math.floor(num / 60);
        const seconds = num % 60;
        return `${minutes}:${seconds.toString().padStart(2, '0')}`;
      }
      return "0:00";
    }
    
    // If it's a number (seconds)
    if (typeof timeData === 'number') {
      const minutes = Math.floor(timeData / 60);
      const seconds = timeData % 60;
      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    }
    
    return "0:00";
  };

  const convertToCSV = (data) => {

      const maxQuests = Math.max(
    ...data.map(item => item.questWiseStatus?.length || 0)
  );

  // ✅ Generate dynamic quest headers
  const questHeaders = Array.from({ length: maxQuests }, (_, i) => `Quest ${i + 1}`);

    const headers = [
      "SN",
      "Name",
      "Email ID",
      "Creator Name",
      "Game Title",
      "Assigned Date",
      "Cohort Name",
      "Started",
      "Completed",
      "Progress",
      "Original Score",
      "Final Score",
      "Improvement",
      "Scenario Pass Attempts",
      "Scenario ReAttempts",
      "Game Replays",
       ...questHeaders,
       "Certification FinalScore",
      "Time Spent",
      "Last Active",
    ];
const formatTimeSpent = (t) => {
  if (!t) return "0:00";

  if (typeof t === "string") {
    const parts = t.split(":").map(Number);

    // Case 1: Already MM:SS → return as is
    if (parts.length === 2) {
      return `${parts[0]}:${String(parts[1]).padStart(2, "0")}`;
    }

    // Case 2: HH:MM:SS → convert to MM:SS
    if (parts.length === 3) {
      const [h, m, s] = parts;
      const totalMinutes = h * 60 + m;
      return `${totalMinutes}:${String(s).padStart(2, "0")}`;
    }
  }

  return "0:00";
};
    const formatPercentage = (value) => {
      if (!value) return "0%";
      if (typeof value === 'object' && value.percentage) return value.percentage;
      if (typeof value === 'string' && value.includes('%')) return value;
      if (typeof value === 'number') return `${Math.round(value)}%`;
      return "0%";
    };

    const rows = data.map((item) => {
      // ✅ Get progress - DON'T modify if already correct
      let progressValue = item.progress;
      
      // Only fix if it's an array or invalid
      if (Array.isArray(progressValue)) {
        progressValue = fixProgressValue(progressValue);
      } else if (typeof progressValue === 'string' && !progressValue.includes('%')) {
        progressValue = fixProgressValue(progressValue);
      } else if (!progressValue) {
        progressValue = "0%";
      }
      
      // ✅ Get time spent - DON'T modify if already correct
      let timeValue = item.Timespend || item.timeSpent || "0:00";
      
      // Only fix if it's not in MM:SS format
      if (typeof timeValue === 'string' && !timeValue.includes(':')) {
        timeValue = fixTimeSpent(timeValue);
      } else if (typeof timeValue === 'number') {
        timeValue = fixTimeSpent(timeValue);
      }
      
      // Debug for atlantistest15
      if (item.lenUserName === "atlantistest15") {
        console.log("🔍 FRONTEND DEBUG:");
        console.log("  Original progress from backend:", item.progress);
        console.log("  Final progress value:", progressValue);
        console.log("  Original Timespend from backend:", item.Timespend);
        console.log("  Final time value:", timeValue);
        console.log("  Completed status:", item.completed);
      }
 const questStatusArray = Array.from({ length: maxQuests }, (_, index) => {
    const quest = item.questWiseStatus?.find(q => q.questNo === index + 1);
    return quest ? quest.status : ""; // blank if missing
  });
      return [
        item.sNo || item.SN || "",
        item.lenUserName || item.Name || "",
        item.lenMail || item["Email ID"] || "",
        item.ctName || item["Creator Name"] || "",
        item.gameTitle || item["Game Title"] || "",
        item.createdDate || item["Assigned Date"] || "",
        item.cohortName || item["Cohort Name"] || "",
        item.started || item.Started || "",
        item.completed || item.Completed || "",
        progressValue,
      //  item.originalScore,
       item.originalScore?.playedScore || item.originalScore || "",
       item.finalScore?.playedScore || item.finalScore || "",
        // formatPercentage(item.finalScore || item["Final Score"]),
        item.Improvement || item.improvement || "0%",
        // item.Timespend || "00:00",
        // item.Timespend ?? "0:00",
        // formatTimeSpent(item.Timespend),
        item.scenario_passAttempts ?? 0,
        item.scenario_reAttempts ?? 0,
        item.totalGameReplies ?? 0,
...questStatusArray,
item.certificationFinalScore ?? 0,
        item.Timespend ? `="${item.Timespend}"` : "0:00",
        // item.Timespend ? `'${item.Timespend}` : "0:00",
        // timeValue,
        item.lastActive || item["Last Active"] || "--"
      ];
    });

    return [headers, ...rows]
      .map((row) => row.map(cell => `"${String(cell ?? '').replace(/"/g, '""')}"`).join(","))
      .join("\n");
  };

  const downloadCSV = (csvData, fileName = "analytics_report.csv") => {
    const blob = new Blob(["\uFEFF" + csvData], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const fetchAllData = async (gameId) => {
    try {
      let foundCompany = [];
      if (UserRole === "Creator") {
        const selectCreatorData = creatorOptions || [];
        foundCompany = selectCreatorData.find(
          (item) => item.value === storageCreatorId
        );
      }

      const requestData = {
        ...selected,
        companyId: selected.companyId
          ? selected.companyId
          : foundCompany?.CompanyId,
        creatorId: selected.creatorId
          ? selected.creatorId
          : foundCompany?.value,
        galGameId: gameId,
        cohortId: selected.cohortId,
        fromDate: selected.fromDate,
        toDate: selected.toDate,
        page: 1,
        limit: pageSize,
      };

      console.log("Download Request Data:", requestData);

      const result = await AnalyticsDataDownloade(JSON.stringify(requestData));

      if (result?.status !== "Success") {
        throw new Error(result?.message || "Failed to fetch data");
      }

      // Debug - check what backend sent
      const user30 = result?.data?.find(d => d.lenUserName === "atlantistest15");
      if (user30) {
        console.log("📦 BACKEND RESPONSE for atlantistest15:");
        console.log("  progress:", user30.progress);
        console.log("  Timespend:", user30.Timespend);
        console.log("  completed:", user30.completed);
        console.log("  lastActive:", user30.lastActive);
      }

      // Format data - keep backend values as is
      const formattedData = result?.data.map((item) => ({
        sNo: item.sNo,
        lenUserName: item.lenUserName,
        lenMail: item.lenMail,
        cpCompanyName: item.cpCompanyName,
        ctName: item.ctName,
        gameTitle: item.gameTitle,
        createdDate: item.createdDate,
        cohortName: item.cohortName,
        started: item.started,
        completed: item.completed,
        progress: item.progress,  // Keep as is from backend
        // originalScore: item.originalScore,
        originalScore: item.originalScore,
        finalScore: item.finalScore,
        Improvement: item.Improvement,
      scenario_passAttempts: item.scenario_passAttempts,
scenario_reAttempts: item.scenario_reAttempts,
totalGameReplies: item.totalGameReplies,
questWiseStatus: item.questWiseStatus,
certificationFinalScore:item.certificationFinalScore,
        QuestReplay: item.QuestReplay,
        Timespend: item.Timespend,  // Keep as is from backend
        lastActive: item.lastActive,
      }));

      return formattedData;

    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };

  const handleAnalyticsDownloade = async () => {
    const gameId = selected?.galGameId;
    
    if (!gameId) {
      toast({
        title: "Error",
        description: "Please select a game first",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    if (isFetchingRef.current) {
      toast({
        title: "Download in progress",
        description: "Please wait for current download to complete",
        status: "info",
        duration: 2000,
        isClosable: true,
      });
      return;
    }

    isFetchingRef.current = true;
    setIsDownloading(true);
    
    try {
      toast({
        title: "Download Started",
        description: "Fetching all data...",
        status: "info",
        duration: 2000,
        isClosable: true,
      });

      const allData = await fetchAllData(gameId);
      
      if (!allData || allData.length === 0) {
        toast({
          title: "No Data",
          description: "No records found for this game",
          status: "warning",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      const csv = convertToCSV(allData);
      const gameTitle = selected?.gameTitle || "analytics";
      const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
      const fileName = `${gameTitle}_analytics_report_${timestamp}.csv`;
      
      downloadCSV(csv, fileName);
      
      toast({
        title: "Download Complete",
        description: `Successfully downloaded ${allData.length} records`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      
    } catch (error) {
      console.error("Download error:", error);
      toast({
        title: "Download Failed",
        description: error.message || "Something went wrong",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsDownloading(false);
      setTimeout(() => {
        isFetchingRef.current = false;
      }, 300);
    }
  };

  return (
    <Stack direction="row" align="center" spacing={4}>
      <Text>Absolute Score</Text>
      <Switch isChecked={isToggled} onChange={handleToggle} />
      <Button 
        colorScheme="blue" 
        onClick={handleAnalyticsDownloade}
        isLoading={isDownloading}
        loadingText="Downloading..."
      >
        Download
      </Button>
    </Stack>
  );
}

export default ToggleSwitch;